import SignUpForm from '../forms/SignUp';
import AuthLayout from '../Assets/AuthLayout';
const SignUpPage = () => {

  return (
    <AuthLayout>
      <div className="w-full max-w-sm h-full overflow-y-auto">
        <SignUpForm />
      </div>
    </AuthLayout>
  );
};

export default SignUpPage;